import { ActivityIndicator, Image,Platform, View } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import TransactionIconFocused from '../../assets/Icons/TransactionIconFocused';
import TransactionIconUnfocused from '../../assets/Icons/TransactionIconUnfocused';
import ManageLimitIconFocused from '../../assets/Icons/ManageLimitIconFocused';
import ManageLimitIconUnfocused from '../../assets/Icons/ManageLimitIconUnfocused';
import HomeIconFocused from '../../assets/Icons/HomeIconFocused';
import HomeIconUnfocused from '../../assets/Icons/HomeIcon';
import TransactionScreen from '../screens/Transactions/Transactions';
import DashboardScreen from '../screens/Dashboard/Dashboard';
import EnterEmail from '../screens/EnterEmail/EnterEmail';
import VerifyEmail from '../screens/VerifyEmail/VerifyEmail';
import Faqs from '../screens/Faqs/Faq';
import ROUTE from './routes';
import VerifyPan from '../screens/VerifyPan/VerifyPan';
import InterestCalculator from '../screens/InterestCalculator/InterestCalculator';
import { BottomTabParamList, PrivateStackParamList } from './types';
import ManageLimit from '@screens/ManageLimit/ManageLimit';
import UserProfile from '../screens/UserProfile/UserProfile';
import AboutUs from '../screens/AboutUs/AboutUs';
import WebviewScreen from '../screens/Webview/WebviewScreen';
import LendingPartners from '../screens/UserProfile/LendingPartners';
import ProductDetails from '../screens/UserProfile/ProductDetails';
import ContactUs from '../screens/UserProfile/ContactUs';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import Loader from '../screens/Loader/Loader';
import { useEffect, useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import { checkColor, removeUrlWithoutReload } from '@app/utils';
import { themeColorSet, ThemedView } from '@app/theme';
import LMSDasboard from '@app/screens/LMSDasboard/LMSDasboard';
import SelectRepayAmount from '@app/screens/SelectRepayAmount/SelectRepayAmount';
import EnterWithdrawalAmount from '@app/screens/EnterWithdrawalAmount/EnterWithdrawalAmount';
import ConfirmWithdrawAmount from '@app/screens/ConfirmWithdrawAmount/ConfirmWithdrawAmount';
import WithdrawalSuccess from '@app/screens/WithdrawalSuccess/WithdrawalSuccess';
import FlexiPay from '@app/screens/FlexiPay/FlexiPay';
import ConfirmPay from '@app/screens/ConfirmPay/ConfirmPay';
import InterestPayment from '@app/screens/InterestPayment/InterestPayment';
import ShortfallDetail from '@app/screens/ShortfallDetail/ShortfallDetail';
import ShortfallRepay from '@app/screens/ShortfallRepay/ShortfallRepay';
import WhatIsShortfall from '@app/screens/WhatIsShortfall/WhatIsShortfall';
import PaymentStatus from '@app/screens/PaymentStatus/PaymentStatus';
import InterestLearnMore from '@app/screens/InterestLearnMore/InterestLearnMore';
import ShortFallLearnMore from '@app/screens/ShortFallLearnMore/ShortFallLearnMore';
import RenewalLearnMore from '@app/screens/RenewalLearnMore/RenewalLearnMore';
import RenewLoan from '@app/screens/RenewLoan/RenewLoan';
import RenewalSummary from '@app/screens/RenewalSummary/RenewalSummary';
import RenewalStatus from '@app/screens/RenewalStatus/RenewalStatus';
import PleadgeMF from '@app/screens/PleadgeMF/PleadgeMF';
import PleadgeMore from '@app/screens/PleadgeMore/PleadgeMore';
import RemovePledge from '@app/screens/RemovePledge/RemovePledge';
import AccountDetails from '@app/screens/AccountDetails/AccountDetails';
import UpdatePhoneNumber from '@app/screens/UpdatePhoneNumber/UpdatePhoneNumber';
import MyLoanDetails from '@app/screens/MyLoanDetails/MyLoanDetails';
import  PledgeHistory from '@app/screens/PledgeHistory/PledgeHistory';
import HowtoCloseAccount from '@app/screens/HowtoCloseAccount/HowtoCloseAccount';
import SelectCloseReason from '@app/SelectCloseReason/SelectCloseReason';
import ConfirmLoanDetails  from '@app/screens/ConfirmLoanDetails/ConfirmLoanDetails';
import UnpledgeInstructions from '@app/screens/UnpledgeInstructions/UnpledgeInstructions';
import PledgeDetails from '@app/screens/PledgeDetails/PledgeDetails';
import ElevateLanding from '@app/screens/ElevateLanding/ElevateLanding';
import OldForeClosure from '@app/screens/OldForeClosure/OldForeClosure';
import RepayDues from '@app/screens/RepayDues/RepayDues';
import ElevateSwitching from '@app/screens/ElevateSwitching/ElevateSwitching';
import UpdateSuccess from '@app/screens/UpdateSuccess/UpdateSuccess';
import FaqScreenRevamp from '@app/screens/FaqScreenRevamp/FaqScreenRevamp';
import FaqDetailsScreenRevamp from '@app/screens/FaqDetailsRevamp/FaqDetailsRevamp';
import HelpAndSupportRevamp from '@app/screens/HelpAndSupportRevamp/HelpAndSupportRevamp';
import PaymentWebView from '../screens/PaymentWebView';
import ViewDetails from '@app/screens/ViewDetail/ViewDetails';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Loading from '@app/sharedComponents/Loading/Loading';
import { updatePartnerParams } from '@app/store/slices/platformSlice';


const Stack = createNativeStackNavigator<PrivateStackParamList>();
const Tab = createBottomTabNavigator<BottomTabParamList>();

type MyTabsProps = {
  navigation: NativeStackNavigationProp<PrivateStackParamList>;
};

function MyTabs({navigation}: MyTabsProps) {
  const { showVoltBottomNavBar, showManageLimit, showTransactionHistory, showHome,target} = useAppSelector((state) => state.platformParams);
  const showBottomBar = showVoltBottomNavBar && ([showManageLimit , showTransactionHistory , showHome].filter(Boolean).length >= 2);
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const [loading,setLoading] = useState(true);
  const dispatch = useAppDispatch();  
  useEffect(()=>{
    AsyncStorage.getItem('show_lms_revamp')
    .then((res)=>{
      // console.log('privateshow_lms_revamp',res)
      if(res === 'false' && isLMSUser!==false){
        navigation.navigate('SPLASHSCREEN');
      }})
      .finally(()=>{
        setLoading(false);
      })
      
    },[isLMSUser])
  
  if (isLMSUser === null || loading) {
    return <Loading/>
  }

  const fetchInitialRoute = () => {
    removeUrlWithoutReload("target")
    if(!target){
      return ROUTE.DASHBOARD_SCREEN;
    }
     setTimeout(() => {
      dispatch(updatePartnerParams({"target": ""}))
    },1000)
    if(target==='transaction'){
      return ROUTE.TRANSACTION_SCREEN;
    }
    if(target==='manageLimit'){
      return ROUTE.MANAGE_LIMIT_SCREEN;
    }else{
      return ROUTE.DASHBOARD_SCREEN;
    }
   
  }

  return (
    <Tab.Navigator
      initialRouteName={fetchInitialRoute()} // Set Transactions as the default tab
      screenOptions={{
        headerShown: false,
        tabBarLabelStyle: {fontSize : 12 , fontFamily : "Inter" },
        tabBarStyle:{backgroundColor : themeColorSet['bg-fill-primary'],borderTopColor : themeColorSet['border-secondary'],borderTopWidth : 1,
          paddingBottom: 8,
          paddingTop: 8,
          height: 60,
          display: showBottomBar ? 'flex' :'none',
        },
        tabBarActiveTintColor: themeColorSet['text-action-primary'],
        tabBarInactiveTintColor: '#667085',
        title: 'Volt - Unlock cash from your mutual funds saving',
      }}
    >
     <Tab.Screen
        options={{
          tabBarLabel: 'Home',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            focused ? <HomeIconFocused/> :
            <HomeIconUnfocused />
          ),
        }}
        name={ROUTE.DASHBOARD_SCREEN}
        component={isLMSUser ? LMSDasboard:DashboardScreen}
      />
     {showTransactionHistory && <Tab.Screen
        options={{
          tabBarLabel: 'Transactions',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            focused ? <TransactionIconFocused />: <TransactionIconUnfocused />
          ),
        }}
        name={ROUTE.TRANSACTION_SCREEN}
        component={TransactionScreen}
      />}
      {showManageLimit && <Tab.Screen
        options={{
          tabBarLabel: 'Manage Limit',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            focused ? <ManageLimitIconFocused />: <ManageLimitIconUnfocused />
          ),
        }}
        name={ROUTE.MANAGE_LIMIT_SCREEN}
        component={ManageLimit}
      />}
    </Tab.Navigator>
  );
}


type PrivateRoutesProps = {
  userDetails: any;
};

const PrivateRoutes = ({ userDetails }: PrivateRoutesProps) => {
  const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail===null;
  const platformParams = useAppSelector((state) => state.platformParams);
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);

  const navigation = useNavigation()
  const {showHome} = platformParams
  useEffect(() => {
    if (Platform.OS !== 'web') {
      // BootSplash.hide({ fade: true })
    }
  }, [])

  useEffect(() => {
    const creditId = userDetails?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    if(creditId!==null || currentStepName === null){
      // navigation.navigate("SPLASHSCREEN")
      return;
    }
  }, [userDetails])

  return (
    <Stack.Navigator
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
         animation: 'slide_from_right', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal', // Direction of the swipe gesture
      }}
      initialRouteName={Platform.OS === 'web' ? ROUTE.LOADING  : ROUTE.HOME}
      
      >
      {Platform.OS === 'web' && <Stack.Screen
        name={ROUTE.LOADING}
        component={Loader}
        options={{ headerShown: false }}
      />}
      {(showHome || isLMSUser) &&
      <Stack.Screen
        name="HOME"
        component={MyTabs}
        options={{ headerShown: false }}
      />}
      {userEmailNotExist && <Stack.Screen
        name={ROUTE.VERIFY_EMAIL}
        component={VerifyEmail}
        options={{ headerShown: false }}
      />}
      {userEmailNotExist && <Stack.Screen
        name={ROUTE.ENTER_EMAIL}
        component={EnterEmail}
        options={{ headerShown: false }}
      />}
      {ROUTE.KYC_PAN_VERIFICATION===currentStepName && <Stack.Screen
        name={ROUTE.KYC_PAN_VERIFICATION}
        component={VerifyPan}
        options={{ headerShown: false }}
      />}
      <Stack.Screen
        name={ROUTE.USER_PROFILE}
        component={UserProfile}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ABOUT_US}
        component={AboutUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WEBVIEW_SCREEN}
        component={WebviewScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LENDING_PARTNERS}
        component={LendingPartners}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PRODUCT_DETAILS}
        component={ProductDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONTACT_US}
        component={ContactUs}
        options={{ headerShown: false }}
      />
         <Stack.Screen
        name={ROUTE.FAQ}
        component={Faqs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_CALCULATOR}
        component={InterestCalculator}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WITHDRAW_AMOUNT}
        component={EnterWithdrawalAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_WITHDRAW_AMOUNT}
        component={ConfirmWithdrawAmount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WITHDRAW_SUCCESS}
        component={WithdrawalSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FLEXI_PAY}
        component={FlexiPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_PAYMENT_DETAILS}
        component={ConfirmPay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_PAYMENT}
        component={InterestPayment}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_DETAILS}
        component={ShortfallDetail}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHORTFALL_REPAY}
        component={ShortfallRepay}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WHAT_IS_SHORTFALL}
        component={WhatIsShortfall}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_STATUS}
        component={PaymentStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_LEARN_MORE}
        component={InterestLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SHOTFALL_LEARN_MORE}
        component={ShortFallLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_LEARN_MORE}
        component={RenewalLearnMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEW_LOAN}
        component={RenewLoan}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.VERIFY_RENEW_LOAN}
        component={RenewalSummary}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.RENEWAL_STATUS}
        component={RenewalStatus}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEADGE_MF}
        component={PleadgeMF}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_MORE}
        component={PleadgeMore}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REMOVE_PLEGE}
        component={RemovePledge}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ACCOUNT_DETAILS}
        component={AccountDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_PHONE_EMAIL}
        component={UpdatePhoneNumber}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOAN_DETAILS}
        component={MyLoanDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_HISTORY}
        component={PledgeHistory}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.OLD_FORECLOSURE}
        component={OldForeClosure}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.REPAY_DUES}
        component={RepayDues}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HOW_TO_CLOSE_ACCOUNT}
        component={HowtoCloseAccount}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.SELECT_CLOSE_REASON}
        component={SelectCloseReason}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONFIRM_LOAN_DETAILS}
        component={ConfirmLoanDetails}
        options={{ headerShown: false }}
      />
         <Stack.Screen
        name={ROUTE.UNPLEDGE_INSTRUCTIONS}
        component={UnpledgeInstructions}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PLEDGE_DETAILS}
        component={PledgeDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ELEVATE_LANDING}
        component={ElevateLanding}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ELEVATE_SWITCHING}
        component={ElevateSwitching}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.UPDATE_ACCOUNT_SUCCESS}
        component={UpdateSuccess}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.HELP_AND_SUPPORT_SCREEN_REVAMP}
        component={HelpAndSupportRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_SCREEN_REVAMP}
        component={FaqScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.FAQ_DETAILS_SCREEN_REVAMP}
        component={FaqDetailsScreenRevamp}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PAYMENT_WEBVIEW}
        component={PaymentWebView}
        options={{ headerShown: false }}
      />
            <Stack.Screen
        name={ROUTE.VIEW_DETAILS}
        component={ViewDetails}
        options={{ headerShown: false }}
      />
      
    </Stack.Navigator>
  );
};
export default PrivateRoutes;
